import React from 'react';

import ChatUserCardModal from '../ChatUserCardModal';
import ChatUserRowOption from '../ChatUserRowOption';
import { WrapperListMembers } from "./components";
import { ChatStreamContext } from "../../../Context/ChatStreamContext";

class ChatMemberList extends React.Component {
  static contextType = ChatStreamContext;

  constructor(props) {
    super(props);

    this.state = {
      searchKey: '',
      memberList: props.members,
      user: null
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { members } = this.props;
    const { memberList } = this.state;
    if (JSON.stringify(memberList) !== JSON.stringify(members)) {
      this.setState({
        memberList: members
      });
    }
  }

  renderMemberList = () => {
    const { memberList } = this.state;

    return (
      <div>
        {memberList.map(({ user }) => (
          <ChatUserRowOption
            key={user.id}
            user={user}
            onClick={ () => {
              // This is intentional do_something blank function
            } }
          />
        ))}
      </div>
    )
  };

  onSearchUser = (searchKey) => {
    const { members } = this.props;
    let memberList = members;

    if (searchKey !== '') {
      memberList = members.filter(({ user }) => {
        return user.name.toLowerCase().includes(searchKey.toLowerCase());
      })
    }

    this.setState({ searchKey, memberList });
  };

  onMessageMember = (user) => { 
    // This is intentional do_something blank function
  };

  onDismissUserCard = () => { this.setState({ user: null }) };

  renderUserCard = () => {
    const { user } = this.state;
    
    if (!user) {
      return null;
    }

    const { navigation } = this.props;
    const loggedUser = navigation.getParam('user');
    
    return (
      <ChatUserCardModal
        user={user}
        loggedUser={loggedUser.id === user.id}
        onDismissUserCard={this.onDismissUserCard}
        onMessageMember={this.onMessageMember}
      />
    )
  };

  render() {
    return (
      <WrapperListMembers>
        {this.renderMemberList()}
      </WrapperListMembers>
    )
  }
}

export default React.memo(ChatMemberList);